<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室分级管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:260px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室编号`">
          <el-input v-model="formInline.training_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-input v-model="formInline.training_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="楼宇">
          <el-select v-model="formInline.building_name" clearable filterable placeholder="请选择"
            @change="handleBuildingChange">
            <el-option v-for="item in buildings" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房间号">
          <el-select v-model="formInline.room_name" clearable filterable placeholder="请选择">
            <el-option v-for="item in rooms" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安全类型">
          <el-select v-model="formInline.safety_category" clearable filterable placeholder="请选择">
            <el-option v-for="(item, index) in $store.state.dangerCategorys" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="130">
        </custom-table-column>
        <custom-table-column fixed prop="training_name" :label="`${$store.state.themeTitle}室名称`" min-width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="140">
        </custom-table-column>
        <custom-table-column prop="building_name" label="楼宇" width="120">
        </custom-table-column>
        <custom-table-column prop="room_name" label="房间号" width="110">
        </custom-table-column>
        <custom-table-column label="安全负责人" width="190">
          <template slot-scope="scope">
            {{ personText(scope.row.secure_person, scope.row.secure_phone) }}
          </template>
        </custom-table-column>
        <custom-table-column :label="`${$store.state.themeTitle}室负责人`" width="190">
          <template slot-scope="scope">
            {{ personText(scope.row.person, scope.row.phone) }}
          </template>
        </custom-table-column>
        <custom-table-column prop="safety_category" label="安全分类" width="130">
        </custom-table-column>
        <custom-table-column label="实训室分级" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.hazards_setting ? scope.row.hazards_setting.level : '' }}
          </template>
        </custom-table-column>
        <!-- <custom-table-column label="危险源" min-width="240">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="(item, index) in descList(scope.row, 'hazard_1ds_desc')" :key="index">
              {{ item }}
            </el-tag>
          </template>
        </custom-table-column>
        <custom-table-column label="风险点" min-width="120">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="(item, index) in descList(scope.row, 'risk_ids_desc')" :key="index">
              {{ item }}
            </el-tag>
          </template>
        </custom-table-column>
        <custom-table-column label="禁止图标" min-width="150">
          <template slot-scope="scope">
            <span v-for="item in settingTags(scope.row, 'no_icon_ids', forbidIcons)" :key="item.id"
              style="margin-right:6px;">
              <img v-if="item.path" :src="item.path" style="width:24px;height:24px;vertical-align:middle;">
              <span v-else>{{ item.name }}</span>
            </span>
          </template>
        </custom-table-column>
        <custom-table-column label="警告图标" min-width="150">
          <template slot-scope="scope">
            <span v-for="item in settingTags(scope.row, 'warn_icon_ids', warnIcons)" :key="item.id"
              style="margin-right:6px;">
              <img v-if="item.path" :src="item.path" style="width:24px;height:24px;vertical-align:middle;">
              <span v-else>{{ item.name }}</span>
            </span>
          </template>
        </custom-table-column>
        <custom-table-column label="防护措施" min-width="120">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="(item, index) in descList(scope.row, 'measures_ids_desc')" :key="index">
              {{ item }}
            </el-tag>
          </template>
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="260">
          <template slot-scope="scope">
            <el-button @click="handleDetailInfo(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="handleHazardSetting(scope.row, 'category')" type="text" size="small">设置分类</el-button>
            <el-button @click="handleHazardSetting(scope.row)" type="text" size="small">设置危险源</el-button>
            <el-button @click="handleScore(scope.row)" type="text" size="small">评分</el-button>
            <el-button @click="handleScoreRecord(scope.row)" type="text" size="small">评分记录</el-button>
            <el-popconfirm title="确定生成安全牌吗？" @confirm="handleSafeCard(scope.row)">
              <el-button slot="reference" type="text" size="small">生成安全牌</el-button>
            </el-popconfirm>
            <el-button @click="handleHazardLog(scope.row)" type="text" size="small">变动记录</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <!-- 设置分类 / 设置危险源(同一对话框) -->
    <el-dialog :close-on-click-modal="false" :title="settingTitle" :visible.sync="settingVisible" width="820px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`">
          <el-input :value="`${ruleForm.training_name}（${ruleForm.training_no}）`" disabled
            style="width:572px;"></el-input>
        </el-form-item>
        <!-- 设置分类:只显示安全类型 -->
        <el-form-item v-if="settingType === 'category'" label="安全类型" prop="safety_category">
          <el-select v-model="ruleForm.safety_category" clearable filterable placeholder="请选择" style="width:572px;">
            <el-option v-for="(item, index) in $store.state.dangerCategorys" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 设置危险源:危险源相关字段 -->
        <template v-if="settingType === 'hazard'">
          <el-form-item label="危险源" prop="hazard_ids">
            <el-select v-model="ruleForm.hazard_ids" multiple filterable clearable placeholder="请选择危险源"
              style="width:572px;" @change="handleHazardChange">
              <el-option v-for="item in hazardOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 系统分级建议:取所选危险源中风险最高(weight 最小)的那条 -->
          <el-form-item label="系统分级建议" v-if="hazardSuggestion">
            <div class="suggest-card">
              <div class="suggest-row">
                <span class="suggest-label">建议等级</span>
                <span class="suggest-value">{{ hazardSuggestion.level }}</span>
              </div>
              <div class="suggest-row">
                <span class="suggest-label">建议检查周期</span>
                <span class="suggest-value">{{ hazardSuggestion.inspection_period }}</span>
              </div>
              <div class="suggest-tip">（依据危险源中最高风险等级）</div>
            </div>
          </el-form-item>
          <el-form-item label="风险点" prop="risk_ids">
            <el-select v-model="ruleForm.risk_ids" multiple filterable clearable placeholder="请先选择危险源"
              style="width:572px;">
              <el-option v-for="item in riskOptions" :key="item.id" :label="item.name" :value="item.id">
                <p>{{ item.name }}</p>
                <p v-if="item.description" class="el-option-tips">描述: {{ item.description }}</p>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维护措施" prop="measures_ids">
            <el-select v-model="ruleForm.measures_ids" multiple filterable clearable placeholder="请先选择危险源"
              style="width:572px;">
              <el-option v-for="item in measuresOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="危险源级别" prop="level_id">
            <el-select v-model="ruleForm.level_id" clearable placeholder="请选择" style="width:216px;"
              @change="onLevelChange">
              <el-option v-for="(item, index) in $store.state.dangerLevels" :key="index" :label="item.level"
                :value="item.id">
                <p>{{ `${item.level}` }}</p>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检查周期" prop="period">
            <el-select v-model="ruleForm.period" clearable placeholder="请选择" style="width:216px;">
              <el-option v-for="(item, index) in $store.state.safePeriods" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="灭火要点" prop="extinguish">
            <el-select v-model="ruleForm.extinguish" multiple filterable clearable placeholder="请选择"
              style="width:572px;">
              <el-option v-for="(item, index) in $store.state.extinguishs" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="禁止图标" prop="no_icon_ids">
            <el-select v-model="ruleForm.no_icon_ids" multiple filterable clearable placeholder="请选择(最多5个)"
              :multiple-limit="5" style="width:216px;">
              <el-option v-for="item in forbidIcons" :key="item.id" :label="item.name" :value="item.id">
                <img v-if="item.path" :src="item.path" style="width:30px;vertical-align:middle;margin-right:6px;">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="警告图标" prop="warn_icon_ids">
            <el-select v-model="ruleForm.warn_icon_ids" multiple filterable clearable placeholder="请选择(最多5个)"
              :multiple-limit="5" style="width:216px;">
              <el-option v-for="item in warnIcons" :key="item.id" :label="item.name" :value="item.id">
                <img v-if="item.path" :src="item.path" style="width:30px;vertical-align:middle;margin-right:6px;">
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', submitSetting)">提交</el-button>
          <el-button @click="handleSettingReset" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 评分:顶部实训室信息 + 按分值分组的多选项列表 -->
    <el-dialog :close-on-click-modal="false" title="评分" :visible.sync="scoreVisible" width="900px">
      <div class="score-head">
        <div class="score-head-main">
          <div class="score-head-title">
            <span class="score-room-name">{{ scoreForm.training_name }}</span>
            <span class="score-room-no">编号：{{ scoreForm.training_no }}</span>
          </div>
          <div class="score-head-total">
            <span class="score-total-label">总分</span>
            <span class="score-total">{{ scoreTotal }}</span>
          </div>
        </div>
        <div class="score-head-sub">
          <span>分类：{{ scoreForm.safety_category }}</span>
          <span>面积（㎡）：{{ scoreForm.area }}</span>
        </div>
      </div>
      <el-tabs v-model="scoreActiveTab">
        <el-tab-pane v-for="group in scoreGroups" :key="group.score"
          :label="`${group.score}分项（${group.checked}/${group.list.length}）`" :name="String(group.score)">
          <div v-for="item in group.list" :key="item.category_id" class="score-item">
            <el-checkbox v-model="item.conform" :true-label="1" :false-label="0" class="score-item-name">
              {{ item.category }}
            </el-checkbox>
            <span class="score-item-score">得分：{{ item.conform == 1 ? item.score : 0 }}</span>
            <el-input class="bz" v-model="item.remark" placeholder="请输入备注" size="small" style="width:240px;"></el-input>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scoreVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitScore">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 评分记录 -->
    <el-dialog :close-on-click-modal="false" title="评分记录" :visible.sync="recordVisible" width="900px">
      <div>
        <el-form :inline="true" :model="recordFormInline" class="demo-form-inline" label-position="left">
          <el-form-item label="评分人">
            <el-input v-model="recordFormInline.create_name" clearable placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="评分时间">
            <el-date-picker v-model="recordDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px;"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleRecordQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <custom-table :data="recordTableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="total_score" label="最终得分" width="100">
        </custom-table-column>
        <custom-table-column prop="create_name" label="评分人" width="140">
        </custom-table-column>
        <custom-table-column prop="count_desc" label="命中项" width="140">
        </custom-table-column>
        <custom-table-column prop="created_at" label="评分时间" min-width="170">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleScoreDetail(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='recordTotal' ref="recordPage" @getList="getRecordList"></PageLine>
      </div>
    </el-dialog>
    <!-- 评分详情 -->
    <el-dialog :close-on-click-modal="false" title="评分详情" :visible.sync="detailVisible" width="900px">
      <div class="score-head">
        <div class="score-head-main">
          <div class="score-head-title" v-if="scoreDetail.training_room">
            <span class="score-room-name">{{ scoreDetail.training_room.training_name }}</span>
            <span class="score-room-no">{{ scoreDetail.training_room.training_no }}</span>
          </div>
          <div class="score-head-total">
            <span class="score-total-label">总分</span>
            <span class="score-total">{{ scoreDetail.total_score }}</span>
          </div>
        </div>
        <div class="score-head-sub">
          <span>评分人：{{ scoreDetail.create_name }}</span>
          <span>评分时间：{{ scoreDetail.created_at }}</span>
          <span>命中项：{{ scoreDetail.count_desc }}</span>
        </div>
      </div>
      <custom-table :data="scoreDetail.category_list || []" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="category" label="评分栏目" min-width="200">
        </custom-table-column>
        <custom-table-column prop="score" label="分值" width="90">
        </custom-table-column>
        <custom-table-column label="是否符合" width="110">
          <template slot-scope="scope">
            {{ scope.row.conform == 1 ? '符合' : '不符合' }}
          </template>
        </custom-table-column>
        <custom-table-column prop="remark" label="备注" min-width="200">
        </custom-table-column>
      </custom-table>
    </el-dialog>
    <!-- 变动记录 -->
    <el-dialog :close-on-click-modal="false" title="变动记录" :visible.sync="logVisible" width="900px">
      <custom-table :data="logTableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="created_at" label="变动时间" width="160">
        </custom-table-column>
        <custom-table-column prop="create_name" label="操作人" width="120">
        </custom-table-column>
        <custom-table-column label="变动内容" min-width="420">
          <template slot-scope="scope">
            <div v-for="(change, index) in logChanges(scope.row)" :key="index" class="log-change-group">
              <div class="log-change-label">{{ change.label }}</div>
              <div class="log-change before">
                <span class="log-change-tag">变更前：</span>{{ change.before || '无' }}
              </div>
              <div class="log-change after">
                <span class="log-change-tag">变更后：</span>{{ change.after || '无' }}
              </div>
            </div>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='logTotal' ref="logPage" @getList="getLogList"></PageLine>
      </div>
    </el-dialog>
    <!-- 详情:基本信息 / 分类设置 / 危险源设置(数据取列表行,不额外请求接口) -->
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailInfoVisible" width="900px">
      <el-descriptions title="基本信息" :column="3" border>
        <el-descriptions-item :label="`${$store.state.themeTitle}室编号`">
          {{ detailRow.training_no }}
        </el-descriptions-item>
        <el-descriptions-item :label="`${$store.state.themeTitle}室名称`">
          {{ detailRow.training_name }}
        </el-descriptions-item>
        <el-descriptions-item label="院系">
          {{ detailRow.structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item label="楼宇">
          {{ detailRow.building_name }}
        </el-descriptions-item>
        <el-descriptions-item label="房间号">
          {{ detailRow.room_name }}
        </el-descriptions-item>
        <el-descriptions-item label="面积（㎡）">
          {{ detailRow.area }}
        </el-descriptions-item>
        <el-descriptions-item label="安全负责人">
          {{ personText(detailRow.secure_person, detailRow.secure_phone) }}
        </el-descriptions-item>
        <el-descriptions-item :label="`${$store.state.themeTitle}室负责人`">
          {{ personText(detailRow.person, detailRow.phone) }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="detail-block" title="分类设置" :column="3" border>
        <el-descriptions-item label="安全类型">
          {{ detailRow.safety_category }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="detail-block" title="危险源设置" :column="2" border>
        <el-descriptions-item :span="2" label="危险源">
          <span class="detail-tags">
            <el-tag size="mini" v-for="(item, index) in detailHazards" :key="index">{{ item }}</el-tag>
            <span v-if="!detailHazards.length" class="detail-empty">未设置</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="风险点">
          <span class="detail-tags">
            <el-tag size="mini" v-for="(item, index) in detailRisks" :key="index">{{ item }}</el-tag>
            <span v-if="!detailRisks.length" class="detail-empty">未设置</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="维护措施">
          <span class="detail-tags">
            <el-tag size="mini" v-for="(item, index) in detailMeasures" :key="index">{{ item }}</el-tag>
            <span v-if="!detailMeasures.length" class="detail-empty">未设置</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="危险源级别">
          {{ detailSetting.level || '未设置' }}
        </el-descriptions-item>
        <el-descriptions-item label="检查周期">
          {{ detailPeriodText || '未设置' }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="灭火要点">
          {{ detailExtinguishText || '未设置' }}
        </el-descriptions-item>
        <el-descriptions-item label="禁止图标">
          <span v-for="item in detailForbidIcons" :key="item.id" class="detail-icon">
            <img v-if="item.path" :src="item.path">
            <span v-else>{{ item.name }}</span>
          </span>
          <span v-if="!detailForbidIcons.length" class="detail-empty">未设置</span>
        </el-descriptions-item>
        <el-descriptions-item label="警告图标">
          <span v-for="item in detailWarnIcons" :key="item.id" class="detail-icon">
            <img v-if="item.path" :src="item.path">
            <span v-else>{{ item.name }}</span>
          </span>
          <span v-if="!detailWarnIcons.length" class="detail-empty">未设置</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingSafeLevel',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        training_no: '',
        training_name: '',
        building_name: '',
        room_name: '',
        safety_category: '',
      },
      buildings: [],
      rooms: [],
      settingVisible: false,
      // 弹窗入口:设置分类 / 设置危险源(共用同一个对话框)
      settingType: 'hazard',
      settingTitle: '设置危险源',
      currentRow: {},
      hazardOptions: [],
      riskOptions: [],
      measuresOptions: [],
      // 已请求过的危险源 id 串,避免同一批重复请求
      loadedHazardIds: '',
      forbidIcons: [],
      warnIcons: [],
      ruleForm: {
        id: '',
        training_no: '',
        training_name: '',
        safety_category: '',
        hazard_ids: [],
        risk_ids: [],
        measures_ids: [],
        level: '',
        level_id: '',
        extinguish: [],
        period: '',
        no_icon_ids: [],
        warn_icon_ids: [],
      },
      // 当前生效的校验(按入口切换):设置分类时不校验危险源相关字段
      rules: {},
      hazardRules: {
        hazard_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        risk_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        extinguish: [{ required: true, message: '请选择', trigger: 'change' }],
        measures_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        level_id: [{ required: true, message: '请选择', trigger: 'change' }],
        period: [{ required: true, message: '请选择', trigger: 'change' }],
        no_icon_ids: [{ required: true, message: '请选择', trigger: 'change' }],
        warn_icon_ids: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      // 评分
      scoreVisible: false,
      scoreActiveTab: '',
      scoreForm: {
        training_room_id: '',
        training_name: '',
        training_no: '',
        safety_category: '',
        area: '',
        category_list: [],
      },
      // 评分记录
      recordVisible: false,
      recordFormInline: {
        create_name: '',
        start_date: '',
        end_date: '',
        training_room_id: '',
      },
      recordDateRange: [],
      recordTableData: [],
      recordTotal: 0,
      // 评分详情
      detailVisible: false,
      scoreDetail: {},
      // 变动记录
      logVisible: false,
      logTableData: [],
      logTotal: 0,
      // 详情(基本信息 / 分类设置 / 危险源设置,直接用列表行)
      detailInfoVisible: false,
      detailRow: {},
    };
  },
  computed: {
    // ===== 详情:危险源设置(没设置过的行 hazards_setting 是空对象) =====
    detailSetting() {
      return this.detailRow.hazards_setting || {};
    },
    detailHazards() {
      return this.descList(this.detailRow, 'hazard_1ds_desc');
    },
    detailRisks() {
      return this.descList(this.detailRow, 'risk_ids_desc');
    },
    detailMeasures() {
      return this.descList(this.detailRow, 'measures_ids_desc');
    },
    detailForbidIcons() {
      return this.settingTags(this.detailRow, 'no_icon_ids', this.forbidIcons);
    },
    detailWarnIcons() {
      return this.settingTags(this.detailRow, 'warn_icon_ids', this.warnIcons);
    },
    // 检查周期:hazards_setting 存的是字典 value,要转成文案
    detailPeriodText() {
      let period = this.detailSetting.period;
      if (!period) return '';
      return this.$until.getLabelName(this.$store.state.safePeriods, 'value', 'label', Number(period));
    },
    // 灭火要点:接口存的是 "禁止用水/沙土掩埋"
    detailExtinguishText() {
      let extinguish = this.detailSetting.extinguish;
      if (!extinguish) return '';
      let list = Array.isArray(extinguish) ? extinguish : String(extinguish).split('/');
      return list.filter(item => item).join('、');
    },
    // 系统分级建议:所选危险源中 weight 最小(风险最高)的一条,没选则为空
    hazardSuggestion() {
      let list = (this.ruleForm.hazard_ids || [])
        .map(id => this.hazardOptions.find(item => String(item.id) === String(id)))
        .filter(item => item);
      if (!list.length) return null;
      return list.reduce((min, item) => (Number(item.weight) < Number(min.weight) ? item : min), list[0]);
    },
    // 评分合计:选中项的分值之和
    scoreTotal() {
      return this.scoreForm.category_list
        .filter(item => item.conform == 1)
        .reduce((sum, item) => sum + (Number(item.score) || 0), 0);
    },
    // 评分项按分值分组(分值从大到小,生成 tabs;checked 是该分值下已选中的条数)
    scoreGroups() {
      let groups = {};
      this.scoreForm.category_list.forEach(item => {
        let key = item.score;
        if (!groups[key]) groups[key] = { score: key, list: [], checked: 0 };
        groups[key].list.push(item);
        if (item.conform == 1) groups[key].checked++;
      });
      return Object.keys(groups).map(key => groups[key]).sort((a, b) => b.score - a.score);
    },
  },
  created() { },
  mounted() {
    // 安全类型字典(接口:api/hazards/hazardCategory)
    this.$store.dispatch('getDangerCategorys');
    // 危险源级别字典(设置危险源弹窗用)
    this.$store.dispatch('getDangerLevels');
    this.getBuildings();
    this.getHazardOptions();
    this.getIcons();
  },
  methods: {
    // 姓名 + 联系方式
    personText(name, phone) {
      return [name, phone].filter(item => item).join(' / ');
    },
    // ===== 详情 =====
    // 基本信息 / 分类设置 / 危险源设置都在列表行里(含 hazards_setting 的描述字段),不额外请求接口
    handleDetailInfo(row) {
      this.detailRow = row;
      this.detailInfoVisible = true;
    },
    // ===== 变动记录:api/hazards/hazardRiskLog =====
    handleHazardLog(row) {
      this.currentRow = row;
      this.logTableData = [];
      this.logTotal = 0;
      this.logVisible = true;
      this.$nextTick(() => {
        if (this.$refs.logPage) this.$refs.logPage.page = 1;
        this.getLogList();
      });
    },
    async getLogList() {
      let pageChild = this.$refs.logPage;
      let params = {
        training_room_id: this.currentRow.id,
        page: pageChild ? pageChild.page : 1,
        size: pageChild ? pageChild.size : 10,
      };
      let res = await this.$api.instance.interfaceServer('api/hazards/hazardRiskLog', 'get', params);
      if (res.code == 0 && res.data) {
        this.logTableData = res.data.data || [];
        this.logTotal = res.data.total || 0;
      }
    },
    // 变动内容:一次提交可能同时改危险源/风险点/危险源级别,按维度拆成"变更前/变更后"对比
    // 前后都为空说明该维度这次没动,不展示
    logChanges(row) {
      return [
        { label: '危险源', before: row.before_hazard_desc, after: row.after_hazard_desc },
        { label: '风险点', before: row.before_risk_desc, after: row.after_risk_desc },
        { label: '危险源级别', before: row.before_level_desc, after: row.after_level_desc },
      ].filter(item => item.before || item.after);
    },
    // ===== 生成/下载安全牌:api/hazards/downloadSafeCard/{id} =====
    // 该接口直接返回 PDF 文件流,要用 blob 方式下载
    async handleSafeCard(row) {
      // 接口需要当前网页域名,开发环境页面跑在 localhost 上,用默认域名
      let domain = process.env.NODE_ENV === 'production' ? location.origin : 'https://xixunyun.cn';
      await this.$until.downloadApiFile(`api/hazards/downloadSafeCard/${row.id}`, `安全牌-${row.training_name}.pdf`, 'post', { domain });
    },
    // 操作列功能开发中
    handleDeveloping(name) {
      this.$message({
        type: 'warning',
        center: true,
        message: `${name}功能开发中，敬请期待！`,
      });
    },
    // ===== 设置分类 / 设置危险源(共用同一个对话框) =====
    // 打开弹窗:按列表行回填
    handleHazardSetting(row, type = 'hazard') {
      this.currentRow = row;
      this.settingType = type;
      this.settingTitle = type === 'category' ? '设置分类' : '设置危险源';
      // 设置分类只改安全类型,不该被危险源/级别的必填校验拦住
      this.rules = type === 'category' ? {} : this.hazardRules;
      // 危险源设置数据都在 hazards_setting 里(没设置过的行是空对象)
      let setting = row.hazards_setting || {};
      this.ruleForm = {
        id: row.id,
        training_no: row.training_no,
        training_name: row.training_name,
        safety_category: row.safety_category || '',
        hazard_ids: this.splitIds(setting.hazard_ids),
        risk_ids: this.splitIds(setting.risk_ids),
        measures_ids: this.splitIds(setting.measures_ids),
        level: setting.level || '',
        // 未设置时接口返回 0,置空避免下拉显示 0
        level_id: setting.level_id ? String(setting.level_id) : '',
        extinguish: setting.extinguish ? setting.extinguish.split('/') : [],
        period: setting.period ? Number(setting.period) : '',
        no_icon_ids: this.splitIds(setting.no_icon_ids),
        warn_icon_ids: this.splitIds(setting.warn_icon_ids),
      };
      this.settingVisible = true;
      // 只有设置危险源才需要拉风险点/维护措施的下拉
      if (this.settingType === 'hazard') this.loadRiskAndMeasures(this.ruleForm.hazard_ids);
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
    },
    handleSettingReset() {
      if (this.currentRow && this.currentRow.id) {
        this.handleHazardSetting(this.currentRow, this.settingType);
      }
    },
    // 危险源变化 → 重新拉风险点/维护措施,并清空已选
    handleHazardChange(ids) {
      this.ruleForm.risk_ids = [];
      this.ruleForm.measures_ids = [];
      this.loadRiskAndMeasures(ids);
    },
    // 危险源下的风险点/维护措施:api/hazards/risk/listByIds/{危险源ids}
    async loadRiskAndMeasures(ids) {
      let hazardIds = ids || this.ruleForm.hazard_ids;
      let idStr = hazardIds.join(',');
      // 同一批危险源只请求一次(实测点一次操作按钮会进来两次,避免重复请求)
      if (idStr === this.loadedHazardIds) return;
      this.loadedHazardIds = idStr;
      this.riskOptions = [];
      this.measuresOptions = [];
      if (!idStr) return;
      let riskRes = await this.$api.instance.interfaceServer(`api/hazards/risk/listByIds/${idStr}`, 'get', {});
      let measuresRes = await this.$api.instance.interfaceServer(`api/hazards/measures/listByIds/${idStr}`, 'get', {});
      if (riskRes.code == 0 && riskRes.data) {
        this.riskOptions = this.listData(riskRes.data).map(item => ({ id: String(item.id), name: item.name, description: item.description }));
      }
      if (measuresRes.code == 0 && measuresRes.data) {
        this.measuresOptions = this.listData(measuresRes.data).map(item => ({ id: String(item.id), name: item.content }));
      }
    },
    // 危险源下拉:api/hazards/total/list
    async getHazardOptions() {
      let res = await this.$api.instance.interfaceServer('api/hazards/total/list', 'get', { page: 1, size: 999 });
      if (res.code == 0 && res.data) {
        // 实测该接口即使带了 page/size 也不是分页结构(res.data.data 为 undefined),用 listData 兼容数组与 {data}
        // 保留 level / weight / inspection_period:分级建议卡片要用(weight 越小风险越高)
        this.hazardOptions = this.listData(res.data).map(item => ({
          id: String(item.id),
          name: item.name,
          level: item.level,
          level_id: item.level_id,
          weight: item.weight,
          inspection_period: item.inspection_period,
        }));
      }
    },
    // 禁止图标 / 警告图标:api/rating/icons?type=xxx
    async getIcons() {
      let forbidRes = await this.$api.instance.interfaceServer('api/rating/icons', 'get', { type: '禁止图标' });
      let warnRes = await this.$api.instance.interfaceServer('api/rating/icons', 'get', { type: '警告图标' });
      if (forbidRes.code == 0 && forbidRes.data) {
        this.forbidIcons = this.listData(forbidRes.data).map(item => ({
          id: String(item.id),
          name: item.name,
          path: item.path,
        }));
      }
      if (warnRes.code == 0 && warnRes.data) {
        this.warnIcons = this.listData(warnRes.data).map(item => ({
          id: String(item.id),
          name: item.name,
          path: item.path,
        }));
      }
    },
    // 选中危险源级别时同步级别文案(接口字段 level / level_id)
    onLevelChange(levelId) {
      this.ruleForm.level = this.getLevelName(levelId);
    },
    getLevelName(levelId) {
      let hit = (this.$store.state.dangerLevels || []).find(item => String(item.id) === String(levelId));
      return hit ? hit.level : '';
    },
    // "67,64" → ['67','64'](未设置时接口可能给 0)
    splitIds(val) {
      if (!val) return [];
      return String(val).split(',').map(item => item.trim()).filter(item => item && item !== '0');
    },
    // hazards_setting 的描述字段:接口有的返回逗号串,有的返回数组
    descList(row, key) {
      let value = (row.hazards_setting || {})[key];
      if (!value) return [];
      return Array.isArray(value) ? value : String(value).split(',').filter(item => item);
    },
    // hazards_setting 里的 id 串 → 选项对象数组(optionList 是已加载的 {id,name,...};找不到就退回 id)
    settingTags(row, key, optionList) {
      let setting = row.hazards_setting || {};
      return this.splitIds(setting[key]).map(id => {
        let hit = (optionList || []).find(item => String(item.id) === String(id));
        return hit || { id: id, name: id };
      });
    },
    // 列表数据:分页结构取 data,否则视为数组
    listData(data) {
      return Array.isArray(data) ? data : ((data && data.data) || []);
    },
    // 提交:按入口分别提交,避免用弹窗里不完整的回填数据覆盖另一部分设置
    async submitSetting() {
      if (this.settingType === 'category') {
        // 设置分类:api/training/safe/level/safetyCategoryUpdate
        let categoryRes = await this.$api.instance.interfaceServer('api/training/safe/level/safetyCategoryUpdate', 'post', {
          id: this.ruleForm.id,
          safety_category: this.ruleForm.safety_category,
        });
        if (categoryRes.code == 0) this.settingSuccess();
        return;
      }
      // 设置危险源:api/hazards/level/update/{id}
      let params = {
        level: this.ruleForm.level,
        level_id: this.ruleForm.level_id,
        hazard_ids: this.ruleForm.hazard_ids.join(','),
        risk_ids: this.ruleForm.risk_ids.join(','),
        measures_ids: this.ruleForm.measures_ids.join(','),
        training_room_id: this.ruleForm.id,
        extinguish: this.ruleForm.extinguish.join('/'),
        period: this.ruleForm.period,
        no_icon_ids: this.ruleForm.no_icon_ids.join(','),
        warn_icon_ids: this.ruleForm.warn_icon_ids.join(','),
      };
      let res = await this.$api.instance.interfaceServer(`api/hazards/level/update/${this.ruleForm.id}`, 'post', params);
      if (res.code == 0) this.settingSuccess();
    },
    // 提交成功后的统一收尾
    settingSuccess() {
      this.$message({
        type: 'success',
        center: true,
        message: '提交成功！',
      });
      this.settingVisible = false;
      this.getList();
    },
    // ===== 评分 =====
    // 打开评分弹窗:拉评分栏目,按分值分组,默认切到分值最高的 tab
    async handleScore(row) {
      this.currentRow = row;
      this.scoreForm = {
        training_room_id: row.id,
        training_name: row.training_name,
        training_no: row.training_no,
        safety_category: row.safety_category,
        area: row.area,
        category_list: [],
      };
      this.scoreActiveTab = '';
      this.scoreVisible = true;
      let res = await this.$api.instance.interfaceServer('api/rating/category/list', 'get', { page: 1, size: 999 });
      if (res.code == 0 && res.data) {
        this.scoreForm.category_list = (res.data.data || []).map(item => ({
          category_id: item.id,
          category: item.category,
          score: item.score,
          conform: 0,
          remark: '',
        }));
        this.scoreActiveTab = this.scoreGroups.length ? String(this.scoreGroups[0].score) : '';
      }
    },
    // 提交评分:api/rating/category/submit
    // category_list 传"索引对象"({0:{...},1:{...}})而不是数组
    async submitScore() {
      let list = this.scoreForm.category_list;
      let categoryList = {};
      list.forEach((item, index) => {
        categoryList[index] = {
          category_id: item.category_id,
          conform: item.conform,
          remark: item.remark,
        };
      });
      let params = {
        training_room_id: this.scoreForm.training_room_id,
        // count 是命中项数(选中项),不是评分栏目总数
        count: list.filter(item => item.conform == 1).length,
        total_score: this.scoreTotal,
        category_list: categoryList,
      };
      // 该接口按 raw-json 收参(表单编码会被后端解析成 null),所以单独走 JSON
      let res = await this.$api.instance.interfaceServer('api/rating/category/submit', 'post', params, {
        isQs: false,
        headersConfig: { 'Content-type': 'application/json;charset=UTF-8' },
      });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.scoreVisible = false;
      }
    },
    // ===== 评分记录 =====
    handleScoreRecord(row) {
      this.currentRow = row;
      this.recordFormInline = {
        create_name: '',
        start_date: '',
        end_date: '',
        training_room_id: row.id,
      };
      this.recordDateRange = [];
      this.recordVisible = true;
      this.$nextTick(() => {
        if (this.$refs.recordPage) this.$refs.recordPage.page = 1;
        this.getRecordList();
      });
    },
    handleRecordQuery() {
      // 日期范围 → start_date / end_date
      let range = this.recordDateRange || [];
      this.recordFormInline.start_date = range.length === 2 ? range[0] : '';
      this.recordFormInline.end_date = range.length === 2 ? range[1] : '';
      this.$refs.recordPage.page = 1;
      this.getRecordList();
    },
    // 评分记录列表:api/rating/list
    async getRecordList() {
      let pageChild = this.$refs.recordPage;
      let params = this.$until.deleteNullPrototype(this.recordFormInline);
      params.page = pageChild ? pageChild.page : 1;
      params.size = pageChild ? pageChild.size : 10;
      let res = await this.$api.instance.interfaceServer('api/rating/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.recordTableData = res.data.data || [];
        this.recordTotal = res.data.total || 0;
      }
    },
    // ===== 评分详情:api/rating/detail/{id} =====
    async handleScoreDetail(row) {
      // 基本信息取列表行(总分/评分人/时间/实训室),明细由详情接口返回
      // category_list 必须在赋值时就存在,否则 Vue 2 追踪不到这个新增属性,列表不会更新
      this.scoreDetail = Object.assign({ category_list: [] }, this.$until.easyDeepCopy(row));
      this.detailVisible = true;
      let res = await this.$api.instance.interfaceServer(`api/rating/detail/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        // 详情接口返回的是明细分页结构,明细在 res.data.data
        this.scoreDetail.category_list = res.data.data || [];
      }
    },
    // 楼宇下拉:api/training/room/building/buildingBySchoolId
    async getBuildings() {
      let res = await this.$api.instance.interfaceServer('api/training/room/building/buildingBySchoolId', 'get', {});
      if (res.code == 0 && res.data) {
        this.buildings = this.listData(res.data).map(item => ({ id: String(item.id), name: item.name }));
      }
    },
    // 房间下拉:api/training/room/building/roomByBuildingId?parent_id=楼宇id
    async getRooms(parentId) {
      let res = await this.$api.instance.interfaceServer('api/training/room/building/roomByBuildingId', 'get', {
        parent_id: parentId,
      });
      if (res.code == 0 && res.data) {
        this.rooms = this.listData(res.data).map(item => ({ id: String(item.id), name: item.name }));
      }
    },
    // 楼宇与房间号级联
    handleBuildingChange(buildingName) {
      this.formInline.room_name = '';
      this.rooms = [];
      if (!buildingName) return;
      let hit = this.buildings.find(item => item.name === buildingName);
      if (hit) this.getRooms(hit.id);
    },
    handleQuery() {
      // 组织结构 → structure_1(院系) / structure_2(专业)
      this.beforeQueryByKeyNew({ dep: 'structure_1', major: 'structure_2', formK: 'formInline' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    // 列表:api/training/safe/level/getList
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/safe/level/getList', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data || [];
        this.total = res.data.total || 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.cell .el-tag {
  margin: 2px 4px 2px 0;
  white-space: wrap;
  height: auto;
}

/* 变动记录:变更前(蓝) / 变更后(绿) 卡片 */
.log-change-group {
  margin-bottom: 8px;
}

.log-change-group:last-child {
  margin-bottom: 0;
}

.log-change-label {
  font-size: 12px;
  color: #909399;
}

.log-change {
  border-radius: 4px;
  padding: 6px 10px;
  margin-top: 2px;
  font-size: 13px;
  line-height: 20px;
}

.log-change-tag {
  font-weight: bold;
}

.log-change.before {
  background: #d9ecff;
}

.log-change.after {
  background: #e1f3d8;
}

/* 详情弹窗:基本信息 / 分类设置 / 危险源设置 */
.detail-block {
  margin-top: 16px;
}

.detail-tags .el-tag {
  margin: 2px 4px 2px 0;
  height: auto;
  white-space: normal;
}

.detail-icon {
  margin-right: 6px;

  img {
    width: 50px;
    vertical-align: middle;
  }
}

.detail-empty {
  color: #909399;
}

/* 系统分级建议卡片(设置危险源弹窗) */
.suggest-card {
  width: 572px;
  box-sizing: border-box;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  padding: 10px 12px;
  line-height: 22px;
}

.suggest-row {
  display: flex;
  align-items: baseline;
  font-size: 13px;
}

.suggest-label {
  width: 96px;
  flex-shrink: 0;
  color: #606266;
}

.suggest-value {
  color: #303133;
  font-weight: bold;
}

.suggest-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

/* 评分弹窗:顶部实训室信息 + 分值分组的项列表 */
.score-head {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 14px 16px;
  margin-bottom: 8px;
}

.score-head-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.score-head-title {
  display: flex;
  align-items: baseline;

  .score-room-name {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  .score-room-no {
    margin-left: 12px;
    font-size: 15px;
    font-weight: bold;
    color: #606266;
  }
}

.score-head-total {
  flex-shrink: 0;

  .score-total-label {
    font-size: 13px;
    color: #909399;
    margin-right: 6px;
  }

  .score-total {
    font-size: 24px;
    font-weight: bold;
    color: #f56c6c;
  }
}

.score-head-sub {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;

  span {
    margin-right: 16px;
  }
}

.score-item {
  display: flex;
  align-items: center;
  padding: 10px 4px;
  border-bottom: 1px dashed #ebeef5;

  .score-item-name {
    flex: 1;
    margin-right: 16px;

    /deep/.el-checkbox__label {
      white-space: normal;
      line-height: 20px;
    }
  }

  .score-item-score {
    width: 110px;
    color: #409eff;
    flex-shrink: 0;
  }
}

@media screen and (max-width: 1000px) {
  .score-item {
    flex-wrap: wrap;
  }

  .bz {
    width: 100% !important;
    margin-top: 8px;
  }
}
</style>
